import(/* webpackMode: "eager" */ "/home/ubuntu/download_production/6a99548286bf030014a177bf_1789317672843_87dccdb9/basketcheck/src/app/register/page.tsx");
